var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: {
      id: "document-previewer",
      "modal-dialog-size": _vm.modalDialogSize,
      "modal-dialog-scrollable": false,
      "loaders-disabled": "",
      "tab-index": null,
      "header-close-button": _vm.headerCloseButton,
    },
    on: { hide: _vm.handleHide },
    scopedSlots: _vm._u(
      [
        {
          key: "header-custom",
          fn: function () {
            return [
              _vm._t("header-custom", null, { loading: _vm.loadingIFrame }),
              _vm._v(" "),
              _c("span", { staticClass: "d-none" }, [
                _vm._v(_vm._s(_vm.$t("global.words.preview"))),
              ]),
            ]
          },
          proxy: true,
        },
        {
          key: "body",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "previewer-container" },
                [
                  _c("document-previewer", {
                    attrs: {
                      "document-type": _vm.fileType,
                      url: _vm.url,
                      "loading-i-frame": _vm.loadingIFrame,
                      loading: _vm.loading,
                    },
                    on: {
                      "update:loadingIFrame": function ($event) {
                        _vm.loadingIFrame = $event
                      },
                      "update:loading-i-frame": function ($event) {
                        _vm.loadingIFrame = $event
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "footer",
          fn: function () {
            return [
              _vm.fileName
                ? _c(
                    "div",
                    {
                      staticClass: "col d-flex flex-row justify-content-center",
                    },
                    [
                      _c(
                        "p",
                        {
                          staticClass: "filename text-center text-truncate",
                          staticStyle: { "max-width": "25rem" },
                        },
                        [
                          _vm._v(
                            "\n        " + _vm._s(_vm.fileName) + "\n      "
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.allowDownload
                ? _c(
                    "simple-button",
                    {
                      attrs: {
                        type: "button",
                        loading: _vm.documentIsDownloading,
                        "class-name": "btn btn-primary btn-sm",
                      },
                      on: { click: _vm.handleDownload },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("global.words.download")) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }